import * as React from 'react';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export interface IFullscreenGalleryCloseButtonProps {
  onClick(): void;
}

export function CloseButton({ onClick }: IFullscreenGalleryCloseButtonProps) {
  return (
    <button type="button" onClick={onClick} className={styles['close_button']} aria-label="Закрыть">
      <IconActionClose16 />
    </button>
  );
}
